var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-config-provider',{attrs:{"renderEmpty":_vm.renderEmpty,"locale":_vm.locale}},[_c('div',{staticClass:"vue-app",class:_vm.isIE9 && 'ie9-vue-app'},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }